import api from '@/api';

const orderUrls = {
  todos: 'orders',
  produtos: 'orders/products',
  assinaturas: 'orders/memberships',
};

export default {
  membershipCancel: code => api.put(`/membership/cancellation/${code}`),
  membershipPayment: (code, formData) => api.put(`/membership/payment-method/${code}`, formData),
  orderDetails: id => api.get(`order/${id}`),
  orderList: (index, page, perPage, origin) => api.get(orderUrls[index], {
    params: {
      page,
      perPage,
      origin,
    },
  }),
  orderTracking: (trackingCode, trackingServiceSlug) => api.get('tracking', {
    params: {
      tracking_code: trackingCode,
      tracking_service_slug: trackingServiceSlug,
    },
  }),
};
